<template lang="pug">
.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
  .match-bet-area-group.flex-grow-2
    hdpItemMMO(:details="mmoDetails" :oddsType="oddsType" betType="hdp")
  .match-bet-area-group.flex-grow-2
    ouItemMMO(:details="mmoDetails" :oddsType="oddsType" betType="ou")
</template>

<script>
import hdpItemMMO from "@/components/mobile/main/xitem/hdpItemMMO";
import ouItemMMO from "@/components/mobile/main/xitem/ouItemMMO";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    hdpItemMMO,
    ouItemMMO
  },
  mixins: [mixinHDPOUOdds]
};
</script>
